import { AxiosRequestConfig, AxiosError } from 'axios';
import axios from 'axios';
import Vue from 'vue';

const config: AxiosRequestConfig = {
  baseURL: '',
  headers: {},
};

const axiosService = axios.create(config);

axiosService.interceptors.response.use(undefined, (error: AxiosError) => {

  Vue.prototype.$snackbar.error(error.message, 5000);

});
axiosService.interceptors.request.use((axiosConfig: AxiosRequestConfig) => {

  return axiosConfig;
});

export default axiosService;
